import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthCustomService } from './auth-custom.service';

@Injectable({
  providedIn: 'root',
})
export class AuthRedirectGuard implements CanActivate {
  constructor(private authCustom: AuthCustomService, private router: Router) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const isAuthenticated = this.authCustom.hasValidToken();
    const currentUrl = state.url;

    if (isAuthenticated && currentUrl.includes('welcome')) {
      this.router.navigate(['/home']);
      return false;
    }

    return true;
  }
}
